/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Action_Rotate2Inputs */

const en_settings_reportingapikeys_action_rotate2 = /** @type {(inputs: Settings_Reportingapikeys_Action_Rotate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotate`)
};

/**
* | output |
* | --- |
* | "Rotate" |
*
* @param {Settings_Reportingapikeys_Action_Rotate2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_action_rotate2 = /** @type {((inputs?: Settings_Reportingapikeys_Action_Rotate2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Action_Rotate2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_action_rotate2(inputs)
});
export { settings_reportingapikeys_action_rotate2 as "settings_reportingApiKeys_action_rotate" }